// frontend/src/components/athleteEditor/EditorField.jsx
import React from 'react';

// state: 'value' | 'empty' | 'verified' | 'derived'
// label + optional unit render as mono "LABEL · UNIT". children is the input
// (and, for verified/unverified value fields, a SealButton positioned inside).
export default function EditorField({ label, unit, state = 'value', hint, className = '', children }) {
  const mod = state === 'empty' ? 'ae-field--empty'
    : state === 'verified' ? 'ae-field--verified'
    : state === 'derived' ? 'ae-field--derived' : '';
  return (
    <div className={`ae-field ${mod} ${className}`.trim()}>
      <label className="ae-field__label">
        {String(label).toUpperCase()}{unit ? ` · ${String(unit).toUpperCase()}` : ''}
      </label>
      <div className="ae-field__control">{children}</div>
      {hint && <span className="ae-field__hint">{hint}</span>}
    </div>
  );
}
